import React from "react";
import { Route, Switch } from "react-router-dom";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import Devices from "./containers/Devices";
import DeviceDetail from "./containers/DeviceDetail";
import Dashboard from "./containers/Dashboard";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>
      
      <UnauthenticatedRoute exact path="/login">
        <Login />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute exact path="/signup">
        <Signup />
      </UnauthenticatedRoute>
      
      <AuthenticatedRoute exact path="/devices">
        <Devices />
      </AuthenticatedRoute>

      <AuthenticatedRoute exact path="/device/:deviceId">
        <DeviceDetail />
      </AuthenticatedRoute>

      <AuthenticatedRoute exact path="/dashboard">
        <Dashboard />
      </AuthenticatedRoute>
      
      <Route>
        <NotFound />
      </Route>

    </Switch>
  );
}